import React, { Fragment } from "react"
import { connect } from "react-redux"
import { Typography } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import API from "store/api"
import { setIsLoading } from "actions/isLoading"
import ReusableFormControl from "../../../../components/ReusableFormControl"
import MaskedOrganizationCode from "../../../../components/MaskedOrganizationCode"

const urlParam = window.location.search ? window.location.search : null
let orgCodeURL = null

if (urlParam) {
  orgCodeURL = new URLSearchParams(urlParam).get("code")
}

const EmployeeCodeSchema = Yup.object().shape({
  employerCode: Yup.string()
    .min(2, "Too Short!")
    .max(6, "Too Long!")
    .required("Required")
})

const EmployerCode = ({
  updateRegData,
  regData,
  classes,
  dispatch,
  formRef
}) => {
  let orgCode

  if (regData.orgCode) {
    orgCode = regData.orgCode
  } else if (orgCodeURL) {
    orgCode = orgCodeURL
  }

  return (
    <Fragment>
      <Typography variant="h2" className={classes.employerCodeTitle}>
        Organization Code
      </Typography>
      {/* <Typography className={classes.registerExplanation}>
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
      </Typography> */}
      <Formik
        innerRef={formRef}
        initialValues={{
          employerCode: orgCode ? orgCode : ""
        }}
        validationSchema={EmployeeCodeSchema}
        onSubmit={(values, actions) => {
          dispatch(setIsLoading(true))
          actions.setStatus(undefined)
          API.get(`/orgs/code/${values.employerCode}`)
            .then(res => {
              dispatch(setIsLoading(false))
              if (res.body.org_id) {
                updateRegData({
                  orgId: res.body.org_id,
                  orgCode: values.employerCode
                })
              } else {
                actions.setStatus({ employerCode: "Code does not exists." })
              }
            })
            .catch(error => {
              console.log(error)
            })
        }}
      >
        {formikProps => (
          <Form className={classes.form}>
            <ReusableFormControl
              name="employerCode"
              label="Organization Code"
              formikProps={formikProps}
              inputProps={{
                inputComponent: MaskedOrganizationCode
              }}
              inputClass={classes.inputReusableFormControl}
              inputLabelClass={classes.labelTextColor}
            />
          </Form>
        )}
      </Formik>
    </Fragment>
  )
}

const mapStateToProps = state => {
  return {}
}

const connector = connect(mapStateToProps)

export default withStyles(styles)(connector(EmployerCode))



// WEBPACK FOOTER //
// ./src/pages/Register/components/EmployerCode/index.jsx